
export type ItemStateType = (
  'new' |
  'highres_available' |
  'progressing' |
  'rendering'|
  'complete' |
  'error' |
  'deleting'
);

export const ItemState: {
  NEW: ItemStateType,
  HIGHRES_AVAILABLE: ItemStateType,
  PROGRESSING: ItemStateType,
  RENDERING: ItemStateType,
  COMPLETE: ItemStateType,
  ERROR: ItemStateType,
  DELETING: ItemStateType
} = {
  NEW: 'new',

  // This state is used by Kelda to indicate that the highres
  // is available from an S3 gateway even though we have not uploaded
  // anything yet to Mimir. When an item is in this state, it should
  // not be allowed in the UI to upload content to the item since this
  // will be taken care of by Kelda uploading an edit proxy
  HIGHRES_AVAILABLE: 'highres_available',

  PROGRESSING: 'progressing',
  RENDERING: 'rendering',
  COMPLETE: 'complete',
  ERROR: 'error',
  DELETING: 'deleting',
};
